module.exports = __webpack_public_path__ + "assets/img/a5.373f4f29.jpg";